export default "__VITE_ASSET__DfNLzfMZ__"